module.exports = __webpack_public_path__ + "static/media/shipping-timed.3dca27c7.svg";